import { Map, fromJS } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';
import {
  FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS,
} from './actions';

export default function progressTestOverview(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_PROGRESS_TEST_OVERVIEW_SUCCESS:
      return state.set(
        action.groupId,
        ApiResponseHelper.create({ data: fromJS(action.payload) }),
      );
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/ProgressTestOverview/reducer.js